import * as CalHistoryConstants from "./CalHistoryConstants";
import { produce } from "immer";
import {
    STATUS_FAILURE,
    STATUS_SUCCESS,
    STATUS_PENDING,
  } from "Common/constants/commonConstants"; 
  

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    testName: "",
    calHistoryTable: [],
    rbHistoryTable: [],
    calibHistoryChart: [],
    rbHistoryChart: [],
    calibLevelData: [],
    availability: null,
    isCalibHistLoading: STATUS_PENDING,
};

const CalHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case CalHistoryConstants.GET_CAL_HISTORY_DATA:
            const getCalHistoryState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    testName: "",
                    calHistoryTable: [],
                    rbHistoryTable: [],
                    calibHistoryChart: [],
                    rbHistoryChart: [],
                    calibLevelData: [],
                    availability: null,
                    isCalibHistLoading: STATUS_PENDING,
                }
            });
            return assign({}, state, getCalHistoryState);

        case CalHistoryConstants.CAL_HISTORY_DATA_FETCHED:
            const fetchedCalHistoryState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    testName: action.payload.newState.testName,
                    calHistoryTable: action.payload.newState.calibLotNumberHistory,
                    rbHistoryTable: action.payload.newState.rbLotNumberHistory,
                    calibHistoryChart: action.payload.newState.calibHistoryChart,
                    rbHistoryChart: action.payload.newState.rbHistoryChart,
                    calibLevelData: action.payload.newState.calibLevelData,
                    availability: action.payload.newState.availability,
                    isCalibHistLoading: STATUS_SUCCESS,
                }
            });
            return assign({}, state, fetchedCalHistoryState);
        case CalHistoryConstants.CAL_HISTORY_DATA_FETCHING_FAILED:
            const failedCalHistoryState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    testName: "",
                    calHistoryTable: [],
                    rbHistoryTable: [],
                    calibHistoryChart: [],
                    rbHistoryChart: [],
                    calibLevelData: [],
                    availability: null,
                    isCalibHistLoading: STATUS_FAILURE,
                }
            });
            return assign({}, state, failedCalHistoryState);
        default:
            return state;
    }
};

export default CalHistoryReducer;
